import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M17.854 6.146l-5-5c-.195-.195-.512-.195-.707 0s-.195.512 0 .707l4.146 4.146H8.5c-3.033 0-5.5 2.467-5.5 5.5v8c0 .276.224.5.5.5s.5-.224.5-.5v-8c0-2.481 2.019-4.5 4.5-4.5h7.793l-4.146 4.146a.5003.5003 0 0 0 0 .707c.098.098.226.146.354.146s.256-.049.354-.146l5-5a.5003.5003 0 0 0 0-.707z',
  ],
  height: 20,
  width: 20,
});
